import { css } from "styled-components";

const DISPLAY_INLINE = css`
  display: inline;
`;

export default DISPLAY_INLINE;



// WEBPACK FOOTER //
// ./src/mixins/displayInline.js